// react
import { useState } from 'react';
// interfaces
import { periodHour } from '../shared/components/TimeLimit/data';
import { IDisabledButtonState, ITime } from '../shared/components/TimeLimit/interfaces';
// helpers
// data

export const periodMinute = 15;

export const useTimeLimit = () => {
	const [time, setTime] = useState<ITime>({ hour: 0, minute: 0 });

	const [buttonDisabledState, setButtonDisabledState] = useState<IDisabledButtonState>({
		isMinusActionHour: false,
		isPlusActionHour: false,
		isMinusActionMinute: false,
		isPlusActionMinute: false,
	});

	/**
	 * Actions
	 */

	const handleMinusHourAction = () => {
		if (!buttonDisabledState.isMinusActionHour) {
			setTime(prevState => ({ ...prevState, hour: prevState.hour - periodHour }));
		}
	};

	const handlePlusHourAction = () => {
		if (!buttonDisabledState.isPlusActionHour) {
			setTime(prevState => ({ ...prevState, hour: prevState.hour + periodHour }));
		}
	};

	const handleMinusMinuteAction = () => {
		if (!buttonDisabledState.isMinusActionMinute) {
			setTime(prevState => ({ ...prevState, minute: prevState.minute - periodMinute }));
		}
	};

	const handlePlusMinuteAction = () => {
		if (!buttonDisabledState.isPlusActionMinute) {
			setTime(prevState => ({
				hour: prevState.minute >= 45 ? prevState.hour + periodHour : prevState.hour,
				minute: prevState.minute >= 45 ? 0 : prevState.minute + periodMinute,
			}));
		}
	};

	//

	return {
		time,
		setTime,
		buttonDisabledState,
		setButtonDisabledState,
		handleMinusHourAction,
		handlePlusHourAction,
		handleMinusMinuteAction,
		handlePlusMinuteAction,
	};
};
